/* narin. — stacked PDP gallery: scroll-bound thumbnail highlighting + parallax.
   (Click-to-scroll is handled natively by Dawn's media-gallery.js.) */
(function () {
  function setup(gallery) {
    if (gallery.__narinG) return;
    var items = gallery.querySelectorAll('.product__media-list > .product__media-item');
    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    if (!items.length || !thumbs.length) return;
    gallery.__narinG = true;

    function setActive(mediaId) {
      gallery.querySelectorAll('.thumbnail-list__item .thumbnail').forEach(function (b) {
        b.removeAttribute('aria-current');
      });
      var li = gallery.querySelector('.thumbnail-list__item[data-target="' + mediaId + '"]');
      var btn = li && li.querySelector('.thumbnail');
      if (btn) {
        btn.setAttribute('aria-current', 'true');
        if (btn.scrollIntoView) btn.scrollIntoView({ block: 'nearest' });
      }
    }

    // Highlight the thumbnail of whichever image is centered in the viewport
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) setActive(e.target.getAttribute('data-media-id'));
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );
      items.forEach(function (it) { io.observe(it); });
    }

    // Subtle parallax on each stacked image (desktop, motion allowed)
    var M = window.Motion;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (M && M.scroll && !reduce && window.innerWidth >= 990) {
      items.forEach(function (it) {
        var img = it.querySelector('img');
        if (!img) return;
        try {
          M.scroll(
            M.animate(
              img,
              { transform: ['scale(1.06) translateY(-2.6%)', 'scale(1.06) translateY(2.6%)'] },
              { easing: 'linear' }
            ),
            { target: it, offset: ['start end', 'end start'] }
          );
        } catch (e) {}
      });
    }
  }

  // Mobile swipe indicators (dots) bound to the horizontal media slider
  function setupDots(gallery) {
    var dots = gallery.querySelector('[data-narin-gallery-dots]');
    var slider = gallery.querySelector('.product__media-list');
    if (!dots || !slider || gallery.__narinDots) return;
    gallery.__narinDots = true;

    function visibleItems() {
      return Array.prototype.filter.call(
        slider.querySelectorAll('.product__media-item'),
        function (it) { return it.offsetParent !== null; }
      );
    }

    function update() {
      var items = visibleItems();
      if (!items.length || !dots.children.length) return;
      var center = slider.scrollLeft + slider.clientWidth / 2;
      var active = 0, best = Infinity;
      items.forEach(function (it, idx) {
        var mid = it.offsetLeft + it.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < best) { best = d; active = idx; }
      });
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }

    function build() {
      var items = visibleItems();
      dots.textContent = '';
      items.forEach(function (it, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'narin-gallery-dot';
        b.setAttribute('aria-label', 'Go to image ' + (idx + 1));
        b.addEventListener('click', function () {
          slider.scrollTo({ left: it.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      update();
    }

    var raf;
    slider.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    window.addEventListener('resize', build);
    // rebuild when variant filtering changes which images are visible
    document.addEventListener('change', function (e) {
      if (e.target.closest('product-info, .product-form, variant-selects, variant-radios')) {
        setTimeout(build, 80);
        setTimeout(build, 520);
      }
    });
    build();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(function (g) {
      setup(g);
      setupDots(g);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
